module.exports = __webpack_public_path__ + "static/media/gery-95.1d477402.jpg";